const second = 1 * 1000
const minute = 60 * second
const hour = 60 * minute
const day = 24 * hour

export { second, minute, hour, day }
